<template>
    <div align="center" style="height: auto">
        <div class="commonSearch bottom" ref="commonSearchRef" :style="defaultHeight">
            <el-card class="box-card1">
                <div>
                    <div>
                        <span style="font-size: 22px;margin-right: 10px">{{form.faulttypeName}}</span>
                        <el-button class="state" v-if="form.status==1" style="border-color: #F56C6C;color: #F56C6C;">新受理</el-button>
                        <el-button class="state" v-if="form.status==2 || form.status==3" style="border-color: #E6A23C;color: #E6A23C;">处理中</el-button>
                        <el-button class="state" v-if="form.status==4 || form.status==5" style="border-color: #67C23A;color: #67C23A;">已完成</el-button>
                    </div>
                    <div style="font-size: 16px;">报修时间:&nbsp;&nbsp;{{form.createdate}}</div>
                    <div style="font-size: 16px;">报修单号:&nbsp;&nbsp;{{form.repaircode}}</div>
                </div>
            </el-card>

            <el-card class="box-card2">
                <el-form class="el-form" label-width="100px" label-position="left">
                    <el-form-item label="学号/工号">
                        <el-input v-model="form.userid" readonly style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="电话">
                        <el-input v-model="form.telephone" readonly style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人">
                        <el-input v-model="form.studentname" readonly style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="故障类型">
                        <el-input v-model="form.faulttypeName" readonly style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="区域">
                        <el-input v-model="form.regionName" readonly style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="楼宇">
                        <el-input v-model="form.bulidingName" readonly style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="详细地址">
                        <el-input v-model="form.detailedaddress" readonly style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="预约时间">
                        <el-input v-model="form.repairtime" readonly style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="故障描述">
                        <el-input type="textarea" :rows="6" readonly placeholder="例如:上不了网,网络慢" v-model="form.faultdescription" style="width: 300px"> </el-input>
                    </el-form-item>
                    <el-form-item label="图片上传">
                        <div class="demo-image" style="width: 350px;height: auto;margin-top: 15px">
                            <div v-if="fits.length==0">
                                暂无图片
                            </div>
                            <div class="block" v-for="(fit,index) in fits" :key="index">
                                <el-image style="width: 100px; height: 100px" :src="showPic(fit)"></el-image>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="视频" v-if="this.videoForm.showVideoPath !=''">
                        <div class="demo-image" style="width: 350px;height: auto;margin-top: 15px">
                            <div class="block">
                                <video :src="videoForm.showVideoPath" class="avatar video-avatar" controls="controls">
                                    您的浏览器不支持视频播放
                                </video>
                            </div>
                        </div>
                    </el-form-item>

                    <div style="margin-top: 9px;margin-left: 30px">
                        <el-button style="color: #508BD5;border-color: #508BD5;" @click="modify(form.orderid)" :disabled="form.status!=1">修改</el-button>
                        <el-button style="color: #508BD5;border-color: #508BD5;" @click="checkSchedule(form.orderid)">查看进度</el-button>
                        <el-button style="color: #508BD5;border-color: #508BD5;" @click="rollBack">返回</el-button>
                    </div>
                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import RepairsApi from "@/api/repairs.js";

export default {
    mixins: [TabResize],
    components: {},

    data () {
        return {
            form: {
                buliding: "",
                createdate: "",
                detailedaddress: "",
                faultdescription: "",
                faulttype: '',
                region: '',
                repaircode: "",
                repairtime: "",
                repersonnel: "",
                status: '',
                studentname: "",
                telephone: "",
                userid: "",
                orderid: ""
            },
            fits: [],
            pictures: [],
            defaultHeight: {
                height: ""
            },
            videoForm: {
                videoid: '',
                showVideoPath: ''
            }
        };
    },

    mounted: function () {
        if (this.$route.query.id != null) {
            let id = this.$route.query.id;
            this.findOrderById(id);
            this.findImg(id)
            this.findvideo(id);
        }
    },

    methods: {
        findOrderById (id) {
            RepairsApi.getClass()
                .findOrderById(id).then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        let data = res2.data.data;
                        data.status = data.status - 100400;
                        this.form = data;
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                }).catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },

        //查看图片
        findImg (id) {
            let typeId = 9981;
            this.$mhttp.httpGet(this.$constant.API_NSC + 'file/files/type/' + typeId + '/record/' + id, null, null).then(res2 => {
                if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                    let data = res2.data.data;
                    for (var i = 0; i < data.length; i++) {
                        this.pictures.push(data[i].id)
                    }
                    this.loadImage(this.pictures);
                } else {
                    this.$message.error(res2.data.msg);
                    return false;
                }
            }).catch(err => {
                this.$message.error(err);
                return false;
            });
        },

        //加载图片
        loadImage (userIcons) {
            let imgIds = userIcons;
            for (var i = 0; i < imgIds.length; i++) {
                RepairsApi.getClass()
                    .downloadFile(imgIds[i])
                    .then(res2 => {
                        let data = res2.data;
                        if (data != null) {
                            this.fits.push(res2.data);
                        } else {
                            this.fits.push("@/assets/images/main/headImg.png");
                        }
                    })
                    .catch(err => {
                        this.fits.push("@/assets/images/main/headImg.png");
                        return false;
                    });
            }
        },
        //展示图片
        showPic (val) {
            return URL.createObjectURL(val);
        },
        findvideo (id) {
            let typeId = 998102;
            this.$mhttp.httpGet(this.$constant.API_NSC + "file/files/type/" + typeId + "/record/" + id, null, null).then((resp) => {
                if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                    let data = resp.data.data;
                    if (this.$utils.isEmpty(data)) {
                        this.videoForm.videoid = data[0].id;
                        this.loadImage2(data[0].id);
                    }
                } else {
                    this.$message.error(resp.data.msg);
                    return false;
                }
            }).catch((err) => {
                this.$message.error(err);
                return false;
            });
        },
        //加载视频
        loadImage2 (userIcons) {
            let imgIds = userIcons;
            RepairsApi.getClass()
                .downloadFile(imgIds)
                .then((resp) => {
                    let data = resp.data;
                    if (data != null) {
                        this.videoForm.showVideoPath = URL.createObjectURL(resp.data);
                    }
                }).catch((err) => {
                    this.$message.error("查询失败");
                    return false;
                });
        },
        //查看进度
        checkSchedule (val) {
            let row = val;
            this.$router.push({
                name: "CheckSchedule",
                query: {
                    id: row
                }
            });
        },
        rollBack () {
            this.$router.push({
                name: "WarrantyList",
            });
        },
        //修改
        modify (val) {
            let row = val;
            this.$router.push({
                name: "CreateWarranty",
                query: { id: row }
            });
        },
        //定义方法，获取高度减去头尾
        getHeight () {
            this.defaultHeight.height = window.innerHeight - 90 + "px";
        }
    },
    created () {
        //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
        window.addEventListener("resize", this.getHeight);
        this.getHeight();
    }
};
</script>

<style lang="stylus" scoped>
.bottom {
    width: 90%;
    height: 820px;
    overflow: auto;
}

/deep/.el-button--small {
    margin-left: 15px;
}

.state {
    font-size: 12px;
    height: 30px;
    width: 65px;
}

.commonSearch .el-form .el-form-item {
    margin-top: 5px !important;
    margin-left: 12px !important;
    margin-right: 0px !important;
    margin-bottom: 5px !important;
    vertical-align: middle !important;
}

.text {
    font-size: 14px;
}

.box-card1 {
    width: 500px;
    height: 110px;
    margin-top: 20px;
    margin-bottom: 15px;
    text-align: left;
}

.box-card2 {
    width: 500px;
    height: 660px;
    overflow: auto;
}

.block {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    display: inline;
}

.video-avatar {
    width: 300px;
    height: 300px;
}

/deep/ .el-input__inner { /* 或者 .s2>>>.el-input__inner */
    width: 300px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-radius: 0px !important; /* 输入框圆角值 */
}

/deep/ .el-textarea__inner { /* 或者 .s2>>>.el-input__inner */
    width: 300px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-radius: 0px !important; /* 输入框圆角值 */
}

/deep/.el-upload--text, /deep/.el-upload-dragger {
    width: 100%;
    height: 100%;

    .el-icon-upload {
        margin: 10px 0;
    }
}
</style>